module.exports = __webpack_public_path__ + "cu.cc4e731c7da282a9c73f.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/cu.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/cu.svg
// module chunks = styles